var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoDbSymbol = function SvgLogoDbSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA4BC",
    d: "M1.277 14.688V5.659l3.867 2.258zM17.78 5.696v9.313l-8.112 4.685-1.623-4.641zM1.435 5.384 5.303 7.64 9.25.87zM9.53.71l.136.079-3.993 6.848L17.57 5.354zM9.318 19.654l-8.04-4.645.136.079 3.91-6.848z"
  })));
};
export default SvgLogoDbSymbol;